var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_1073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.790039,
    y: 0.148193,
    width: 15.4286,
    height: 14.9599,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_1073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50416 13.5498C7.74592 13.5498 7.03548 13.4107 6.37284 13.1326C5.71021 12.8545 5.13246 12.4766 4.6396 11.9987C4.14676 11.5208 3.75693 10.9606 3.47012 10.3181C3.1833 9.67558 3.03989 8.98672 3.03989 8.25152C3.03989 7.51631 3.1833 6.82746 3.47012 6.18495C3.75693 5.54244 4.14676 4.98225 4.6396 4.50436C5.13246 4.02649 5.71021 3.6485 6.37284 3.3704C7.03548 3.09229 7.74592 2.95324 8.50416 2.95324C9.2624 2.95324 9.97283 3.09229 10.6355 3.3704C11.2981 3.6485 11.8759 4.02649 12.3687 4.50436C12.8616 4.98225 13.2514 5.54244 13.5382 6.18495C13.825 6.82746 13.9684 7.51631 13.9684 8.25152C13.9684 8.98672 13.825 9.67558 13.5382 10.3181C13.2514 10.9606 12.8616 11.5208 12.3687 11.9987C11.8759 12.4766 11.2981 12.8545 10.6355 13.1326C9.97283 13.4107 9.2624 13.5498 8.50416 13.5498ZM10.4154 10.7616L11.0929 10.1047L8.98628 8.06212V5.13488H8.02203V8.44092L10.4154 10.7616ZM4.48877 1.94873L5.16623 2.60561L2.68137 5.01499L2.00391 4.35811L4.48877 1.94873ZM12.5195 1.94873L15.0044 4.35811L14.3269 5.01499L11.8421 2.60561L12.5195 1.94873ZM8.50416 12.6148C9.7536 12.6148 10.816 12.1905 11.6912 11.3418C12.5665 10.4931 13.0042 9.46301 13.0042 8.25152C13.0042 7.04003 12.5665 6.00994 11.6912 5.16124C10.816 4.31256 9.7536 3.88822 8.50416 3.88822C7.25471 3.88822 6.19235 4.31256 5.31706 5.16124C4.44179 6.00994 4.00416 7.04003 4.00416 8.25152C4.00416 9.46301 4.44179 10.4931 5.31706 11.3418C6.19235 12.1905 7.25471 12.6148 8.50416 12.6148Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm02);
export default __webpack_public_path__ + "static/media/alarm02.bf20218c990f87221695a84ecabe4901.svg";
export { ForwardRef as ReactComponent };